<div id="custom" class="leaflet-bar leaflet-control">
  <!--  <a class="leaflet-control-zoom-in" (click)="test($event)" href="#" title="Zoom in" role="button" aria-label="Zoom in">+</a>
    <a class="leaflet-control-zoom-out" href="#" title="Zoom out" role="button" aria-label="Zoom out">−</a>
  -->
</div>
